import React from "react";
import "./sidebar.css";
import SidebarRow from "./SidebarRow";
import HomeIcon from "@mui/icons-material/Home";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import HistoryIcon from "@mui/icons-material/History";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import TheatersIcon from "@mui/icons-material/Theaters";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import SportsCricketIcon from "@mui/icons-material/SportsCricket";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import DiamondIcon from "@mui/icons-material/Diamond";
import SettingsIcon from "@mui/icons-material/Settings";
import FlagIcon from "@mui/icons-material/Flag";
import HelpIcon from "@mui/icons-material/Help";
import FeedbackIcon from "@mui/icons-material/Feedback";

function Sidebar() {
  return (
    <div className="sidebar">
      <SidebarRow selected Icon={HomeIcon} title="Home" />
      <SidebarRow Icon={WhatshotIcon} title="Trending" />
      <SidebarRow Icon={SubscriptionsIcon} title="Subscribtion" />
      <hr />
      <SidebarRow Icon={VideoLibraryIcon} title="Librery" />
      <SidebarRow Icon={HistoryIcon} title="History" />
      <SidebarRow Icon={OndemandVideoIcon} title="Your Videos" />
      <SidebarRow Icon={WatchLaterIcon} title="Watch Later" />
      <SidebarRow Icon={ThumbUpIcon} title="Liked Videos" />
      <SidebarRow Icon={KeyboardArrowDownIcon} title="Show more" />
      <hr />
      <h3 className="sidebar-text">Explore</h3>
      <SidebarRow Icon={MusicNoteIcon} title="Music" />
      <SidebarRow Icon={TheatersIcon} title="Movie" />
      <SidebarRow Icon={LiveTvIcon} title="Live" />
      <SidebarRow Icon={NewspaperIcon} title="News" />
      <SidebarRow Icon={SportsCricketIcon} title="Gamming" />
      <SidebarRow Icon={SportsEsportsIcon} title="Spots" />
      <SidebarRow Icon={LocalLibraryIcon} title="Learning" />
      <SidebarRow Icon={DiamondIcon} title="Fashion" />
      <hr />
      <SidebarRow Icon={SettingsIcon} title="Setting" />
      <SidebarRow Icon={FlagIcon} title="History" />
      <SidebarRow Icon={HelpIcon} title="Help" />
      <SidebarRow Icon={FeedbackIcon} title="Feedback" />
    </div>
  );
}

export default Sidebar;
